
import { useState } from 'react';
import WhatsAppButton from '../../components/feature/WhatsAppButton';
import GalleryHeader from './components/GalleryHeader';
import GalleryHero from './components/GalleryHero';
import GalleryGrid from './components/GalleryGrid';
import GalleryFooter from './components/GalleryFooter';
import { Link } from 'react-router-dom';

export default function GalleryPage() {
  const [selectedImage, setSelectedImage] = useState<string | null>(null);

  const closeModal = () => {
    setSelectedImage(null);
    document.body.style.overflow = 'auto';
  };

  const openImage = (image: string) => {
    setSelectedImage(image);
    document.body.style.overflow = 'hidden';
  };

  return (
    <div className="min-h-screen bg-white font-['Poppins',sans-serif]">
      <GalleryHeader />
      <GalleryHero />
      
      {/* Grid de Fotos */}
      <GalleryGrid onImageClick={openImage} />

      {/* CTA */}
      <section className="py-16 md:py-24 bg-gradient-to-br from-[#010E31] to-[#0a1f4d]">
        <div className="container mx-auto px-4 md:px-6 text-center">
          <h2 className="text-2xl md:text-4xl font-bold text-white mb-4">
            Gostou dos nossos trabalhos?
          </h2>
          <p className="text-white/80 text-base md:text-lg mb-8 max-w-2xl mx-auto">
            Entre em contato conosco e solicite um orçamento gratuito para o seu projeto
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="https://api.whatsapp.com/send?phone=551974098245"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-2 bg-[#25D366] hover:bg-[#20BA5A] text-white font-semibold px-8 py-4 rounded-full transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-whatsapp-line text-xl"></i>
              Solicitar Orçamento
            </a>
            <Link
              to="/"
              className="inline-flex items-center justify-center gap-2 bg-white/10 hover:bg-white/20 text-white font-semibold px-8 py-4 rounded-full transition-all duration-300 border border-white/30 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-arrow-left-line text-xl"></i>
              Voltar ao Início
            </Link>
          </div>
        </div>
      </section>

      <GalleryFooter />
      <WhatsAppButton />

      {/* Modal de Imagem */}
      {selectedImage && (
        <div className="fixed inset-0 z-[100] flex items-center justify-center">
          <div
            className="absolute inset-0 bg-black/90 backdrop-blur-sm"
            onClick={closeModal}
          ></div>
          <div className="relative z-10 max-w-5xl w-full mx-4">
            <button
              onClick={closeModal}
              className="absolute -top-12 right-0 w-10 h-10 bg-white/20 hover:bg-white/40 text-white rounded-full flex items-center justify-center transition-colors duration-300 cursor-pointer"
            >
              <i className="ri-close-line text-xl"></i>
            </button>
            <img
              src={selectedImage}
              alt="Projeto Alumiinnova"
              className="w-full h-auto max-h-[80vh] object-contain rounded-lg"
            />
          </div>
        </div>
      )}
    </div>
  );
}
